(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/pages/preview/components/preview-header.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/pages/preview/components/preview-header.js');
"use strict";


const PreviewHeader = () => React.createElement("h1", {
  className: "tg-preview-header f-center"
}, "F\xF6rhandsgranska ditt k\xF6p");
svs.tickets_giftshop.preview.components.PreviewHeader = PreviewHeader;

 })(window);